export default __webpack_public_path__ + "static/media/gallery-img-4.758131be.jpg";